import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { eventTypesActions } from '.';
import { ApiError } from '../../models/common/api-error';
import { of } from 'rxjs';
import { EventTypesService } from '../../services/event-types.service';

@Injectable({
  providedIn: 'root',
})
export class EventTypesEffects {
  constructor(
    private store$: Store,
    private actions$: Actions,
    private eventTypesService: EventTypesService,
  ) {}

  findAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(eventTypesActions.findAll),
      withLatestFrom(this.store$),
      mergeMap(([action, store]) => {
        return this.eventTypesService.findAll().pipe(
          map((response) =>
            eventTypesActions.findAllSuccess({
              eventTypes: response.data,
            }),
          ),
          catchError((error: ApiError) =>
            of(eventTypesActions.findError({ error: error.message })),
          ),
        );
      }),
    ),
  );
}
